var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMinus = function SvgMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    focusable: false
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91 594q-30 0-51.5-21.5T18 521q0-30 21.5-51.5T91 448h842q30 0 51.5 21.5T1006 521q0 30-21.5 51.5T933 594H91z"
  })));
};
export { SvgMinus as ReactComponent };
export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSAiZGF0YTppbWFnZS9zdmcreG1sO2Jhc2U2NCxQSE4yWnlCMmFXVjNRbTk0UFNJd0lEQWdNVEF5TkNBeE1ESTBJaUI0Yld4dWN6MGlhSFIwY0RvdkwzZDNkeTUzTXk1dmNtY3ZNakF3TUM5emRtY2lQanh3WVhSb0lHUTlJazA1TVNBMU9UUnhMVE13SURBdE5URXVOUzB5TVM0MVZERTRJRFV5TVhFd0xUTXdJREl4TGpVdE5URXVOVlE1TVNBME5EaG9PRFF5Y1RNd0lEQWdOVEV1TlNBeU1TNDFWREV3TURZZ05USXhjVEFnTXpBdE1qRXVOU0ExTVM0MVZEa3pNeUExT1RSSU9URjZJaTgrUEM5emRtYysi";